function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".delete" + shadowSelector + " {position: absolute;right: 4px;top: 4px;border-radius: 50%;background-color: rgb(255, 255, 255);border: 0.75px solid rgb(221, 219, 218);box-shadow: 0px 2px 2px 0px rgb(0 0 0 / 10%);width: 26px;height: 26px;justify-content: center;align-items: center;cursor: pointer;}.delete:hover" + shadowSelector + " {background: var(--c360-g-color-palette-blue-95);}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];